import { FacilityDto } from "../Models";

export interface IFacilityService {
    getFacilitiesForList: (type?: number) => ng.IPromise<FacilityDto[]>;
}